import React from 'react';
import { connect } from 'tanok';
import { ERROR_UNIQUE_USERS } from '@evo/chat-core';

import { Chat } from './chat';
import { Authentication } from './authentication';
import { CompanyBan } from './company';
import { Client } from './client';
import { Notify } from './notify';

import { Network } from '../components/network';

import {
    ERROR_NETWORK_UNAVAILABLE,
} from '../../libs/constants';


class ChatContainerView extends React.Component {
    renderContent() {
        const { userId, companyBanId, clientsUserId, shouldNotify } = this.props;

        if (shouldNotify) return (
            <Notify
                closeDialog={this.props.closeDialog}
                backToChatList={this.props.backToChatList}
            />
        );

        if (!userId) return (
            <Authentication closeDialog={this.props.closeDialog} />
        );

        if (companyBanId) return (
            <CompanyBan closeDialog={this.props.closeDialog} />
        );

        if (clientsUserId) return (
            <Client closeDialog={this.props.closeDialog} />
        );

        return (
            <Chat
                closeDialog={this.props.closeDialog}
                sendMsg={this.props.sendMsg}
                retrySendMsg={this.props.retrySendMsg}
                retrySendFile={this.props.retrySendFile}
                retrySendFileCtx={this.props.retrySendFileCtx}
                sendTyping={this.props.sendTyping}
                sendCtx={this.props.sendCtx}
                markMsgRead={this.props.markMsgRead}
                chatMsgChange={this.props.chatMsgChange}
                openRoom={this.props.openRoom}
                backToChatList={this.props.backToChatList}
            />
        );
    }

    render() {
        const { networkNotify } = this.props;

        return(
            <React.Fragment>
                {this.renderContent()}

                {/* TODO reconnect updates */}
                {networkNotify && <Network onReconnect={() => {}} />}
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    const shouldNotify = !(state.getIn(['errors', ERROR_UNIQUE_USERS])) === false;
    const networkNotify = state.getIn(['errors', ERROR_NETWORK_UNAVAILABLE]);

    return {
        userId: state.get('userId'),
        companyBanId: state.get('companyBanId'),
        clientsUserId: state.get('clientsUserId'),
        errors: state.get('errors'),
        shouldNotify,
        networkNotify
    };
};

export const ChatContainer = connect(mapStateToProps)(ChatContainerView);
